<span class="two-line__primary">{{ primary }}</span>
@if (secondary) {
  <span class="two-line__secondary">{{ secondary }}</span>
}
